module.exports = __webpack_public_path__ + "static/media/aixin.49a72f97.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/aixin.png
// module id = 1711
// module chunks = 0 1